var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgVuesaxOutlineDocumentSketch(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "{props.color}",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9 22.75c-5.43 0-7.75-2.32-7.75-7.75V9c0-5.43 2.32-7.75 7.75-7.75h5c.41 0 .75.34.75.75s-.34.75-.75.75H9C4.39 2.75 2.75 4.39 2.75 9v6c0 4.61 1.64 6.25 6.25 6.25h6c4.61 0 6.25-1.64 6.25-6.25v-5c0-.41.34-.75.75-.75s.75.34.75.75v5c0 5.43-2.32 7.75-7.75 7.75H9z",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18 10.75c-3.42 0-4.75-1.33-4.75-4.75V2c0-.3.18-.58.46-.69.28-.12.6-.05.82.16l8 8c.21.21.28.54.16.82a.74.74 0 0 1-.69.46h-4zM14.75 6c0 2.58.67 3.25 3.25 3.25h2.19l-5.44-5.44V6zM8.48 18.23l-2.46-2.46c-.54-.54-.63-1.45-.21-2.09l1.13-1.7c.28-.43.86-.74 1.38-.74h2.65c.51 0 1.09.31 1.38.74l1.13 1.69c.42.63.33 1.55-.21 2.09l-2.46 2.46c-.3.32-.72.49-1.16.49-.44 0-.86-.17-1.17-.48zm-.29-5.4-1.12 1.69c-.03.04-.02.16.02.2l2.46 2.46c.05.05.17.05.22 0l2.46-2.46c.04-.04.05-.15.02-.2l-1.13-1.69a.458.458 0 0 0-.14-.07l-2.65-.01c-.04.01-.12.05-.14.08z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVuesaxOutlineDocumentSketch);
export default __webpack_public_path__ + "static/media/vuesax-outline-document-sketch.46157b98195803c39551cf7d0e0230e9.svg";
export { ForwardRef as ReactComponent };